module.exports = __webpack_public_path__ + "img/back_address2.03088f13.png";